/* eslint-disable camelcase */
import common from '@/lang/modules/common/CommonCN';
import decision from '@/lang/modules/decision/DecisionEN';
import material from '@/lang/modules/material/MaterialEN';
import requirement from '@/lang/modules/requirement/RequirementCN';
import purchaseorder from '@/lang/modules/purchaseorder/PurchaseorderCN';
import system from '@/lang/modules/system/SystemCN';
import settlement from '@/lang/modules/settlement/SettlementCN';
import evaluationApplication from '@/lang/modules/evaluation-application/EvaluationApplicationCN';
import evaluationResults from '@/lang/modules/evaluation-results/EvaluationResultsEN';
import evaluationMetrics from '@/lang/modules/evaluation-metrics/EvaluationMetricsCN';
// 商户号
// import personalWorkstation from '@/lang/modules/personal-workstation/PersonalWorkstationCN';
import merchantManagement from '@/lang/modules/merchant-management/MerchantManagementCN';
import qualificationManagement from '@/lang/modules/qualification-management/QualificationManagementCN';
import systemManagement from '@/lang/modules/system-management/SystemManagementCN';
import certificateManagement from '@/lang/modules/certificate-management/CertificateManagementCN';
import authorizationLetterManagement from './modules/authorization-letter-management/AuthorizationLetterManagementCN';
import changeManagement from './modules/change-management/ChangeManagementCN';
// 推广费
import portal from './modules/portal/PortalCN';
// import inquiry from '@/lang/modules/inquiry/cn';
// 配置管理
import configManagement from './modules/config-management/ConfigManagementCN';

const commonLang: any = {
	route: {
		// 系统管理
		system: '系统管理',
		systemDictionary: '系统字典',
		systemRuleConfiguration: '规则配置',
		systemInformationMaintenance: 'BG信息维护',
		systemCompanyInformation: '公司信息列表',
		systemWhitelistInformationMaintenance: '白名单信息维护',
		systemAgentMaintenance: '代理人信息维护',
		systemBankInformationMaintenance: '银行号信息维护',
		systemTimedTask: '定时任务管理',
		systemAsynchronousTask: '异步任务管理',
		systemOperationTool: '运营工具',
		// 个人工作台
		personalWorkstation: '个人工作台',
		myPending: '我的待办',
		myApproval: '我的已办',
		myDraft: '我的草稿',
		myMerchantList: '我的商户号',
		myProfile: '个人信息变更',

		// 配置管理
		configManagement: '配置管理',
		messageManagement: '消息管理',

		// 信息维护
		profileMaintain: '个人信息维护',
		changeAdmin: '超管管理员信息录入/修改',
		// 商户号管理
		merchantManagement: '商户号管理',
		merchantQuery: '商户号查询',
		// merchantApply: '商户号开立',
		merchantApply: '商户号开立申请',
		merchantApplyDetail: '商户号开立详情',
		merchantInformationChange: '商户号信息变更',
		merchantRightChange: '商户号权限变更',
		merchantLogOut: '商户号注销',
		merchantRightChangeCreate: '商户号权限变更申请',
		merchantInformationChangeCreate: '商户号信息变更申请',
		merchantLogOutDetails: '商户号注销申请详情',
		merchantInformationChangeDetail: '商户号信息变更申请详情',
		merchantRightChangeDetail: '商户号权限变更详情',
		merchantTypePermissionChange: '商户号类型权限变更',

		merchantBankInfoMaintain: '商户号收款账户信息维护',

		// 商户号证书管理
		merchantCertificateManagement: '证书密钥管理',
		certificateApply: '证书密钥申请',
		merchantCertificateKeyApproval: '证书密钥申请查询',
		merchantCertificateDetails: '详情',
		merchantCertificateMaintain: '证书密钥录入',
		merchantSign: '商户号信息查看',
		adminChangeCreate: '商户号超管变更申请',
		adminChangeQuery: '商户号超管变更查询',
		adminChangeDetail: '商户号超管变更详情',

		// 商户资质管理
		qualificationManagement: '主体资质管理',
		subjectMaintain: '主体资质查询',
		subjectMaintainEntry: '主体资质录入',
		legalMaintainEntey: '法代信息录入',
		subjectImport: '主体资质导入',
		subjectMaintainDetail: '主体资质详情',
		// 打款验证
		paymentVerification: '打款验证',
		paymentVerificationCreate: '商户号进件打款验证',
		adminPaymentVerificationCreate: '超管变更打款验证',
		paymentVerificationQuery: '打款验证查询',
		paymentVerificationDetail: '打款验证详情',
		// 变更管理
		changeManagement: '信息变更管理',
		changeApply: '信息变更申请',
		changeQuery: '信息变更查询',
		changeApplyDetail: '信息变更申请详情',
		changeMerchantInfoQuery: '商户号信息修改查询',
		changeMerchantBaseInfo: '修改-商户号基本信息',
		changeMerchantDetail: '商户号信息修改详情',
		changeMerchantSubjectInfo: '修改-商户号主体信息',
		changeMerchantSettlementInfo: '修改-商户号结算信息',
		changeMerchantLegalInfo: '修改-商户号法代信息',

		// 授权函管理
		authorizationLetterManagement: '法代授权函管理',
		authorizationLetterQuery: '法代授权函新增和查询',

		// 评估申请
		apply: '评估申请',
		createApply: '授信申请',
		myApplySearch: '我的申请单查询',
		applySearch: '申请查询',
		applyDetail: '申请详情',
		myEvaluateDetail: '我的申请详情',
		csigApplicationBrowser: '评估申请浏览',
		// 评估指标
		index: '评估指标',
		createIndex: '指标录入',
		batchCreateIndex: '指标上传',
		indexSearch: '指标查询',
		indexDetails: '指标单详情',
		// 评估结果
		evaluate: '评估结果',
		myEvaluateSearch: '我的结果单查询',
		evaluateSearch: '结果单查询',
		evaluateDetailAMS: '结果单详情',
		evaluateDetailCSIG: '结果单详情',
		myEvaluateDetailAMS: '结果单详情',
		myEvaluateDetailCSIG: '结果单详情',
		// 额度账期
		accountAmount: '额度账期',
		amountRevisionSearch: '额度调整查询',
		csigEffectiveQuery: 'CSIG生效查询',
		amsAmountRevision: 'AMS额度调整',
		csigAmountRevision: 'CSIG额度调整',
		// 外部指标
		external: '外部指标',
		customerPeportSearch: '客户报告查询',
		customerCounting: '计平指标查询',
		// 舆情分析
		publicOpinionAnalysis: '舆情分析',
		publicOpinionQuery: '舆情查询',
		publicOpinionDetails: '舆情详情',
		creditAnalysis: '信用分析',
		// 配置数据
		configurationData: '配置数据',
		indexAllocation: '指标配置',
		relationshipBetweenGradeAndAccountPeriodQuota: '等级与账期额度关系',
		creditSalesRatioAndGradingRelationship: '赊销比与评分等级关系',
		// 其他
		systemName: '供应商门户管理平台',
		dashboard: '首页',
		documentation: '文档',
		guide: '引导页',
		dynamic: '动态渲染',
		permission: '权限测试页',
		rolePermission: '角色权限',
		pagePermission: '页面权限',
		directivePermission: '指令权限',
		icons: '图标',
		components: '组件',
		tinymce: '富文本编辑器',
		markdown: 'Markdown',
		jsonEditor: 'JSON 编辑器',
		splitPane: 'Splitpane',
		avatarUpload: '头像上传',
		dropzone: 'Dropzone',
		sticky: 'Sticky',
		countTo: 'Count To',
		componentMixin: '小组件',
		backToTop: '返回顶部',
		draggableDialog: '可拖拽对话框',
		draggableKanban: '可拖拽看板',
		draggableList: '可拖拽列表',
		draggableSelect: '可拖拽选择',
		charts: '图表',
		barChart: '柱状图表',
		lineChart: '折线图',
		mixedChart: '混合图表',
		example: '综合实例',
		nested: '路由嵌套',
		menu1: '菜单 1',
		'menu1-1': '菜单 1-1',
		'menu1-2': '菜单 1-2',
		'menu1-2-1': '菜单 1-2-1',
		'menu1-2-2': '菜单 1-2-2',
		'menu1-3': '菜单 1-3',
		menu2: '菜单 2',
		table: '表格',
		dynamicTable: '动态表格',
		draggableTable: '可拖拽表格',
		inlineEditTable: '表格内编辑',
		complexTable: '综合表格',
		tab: '分栏',
		form: '表单',
		createArticle: '创建文章',
		editArticle: '编辑文章',
		articleList: '文章列表',
		errorPages: '错误页面',
		page401: '401',
		page404: '404',
		errorLog: '错误日志',
		excel: 'Excel',
		exportExcel: '导出 Excel',
		selectExcel: '导出 已选择项',
		mergeHeader: '导出 多级表头',
		uploadExcel: '上传 Excel',
		zip: 'Zip',
		pdf: 'PDF',
		exportZip: '导出 Zip',
		theme: '换肤',
		clipboard: '粘贴板',
		i18n: '国际化',
		externalLink: '外链',
		profile: '个人中心'
	},
	navbar: {
		logOut: '退出登录',
		dashboard: '首页',
		github: '项目地址',
		theme: '换肤',
		size: '布局大小',
		profile: '个人中心',
		feedback: '意见反馈',
		financeDepartment: '财经线'
	},
	login: {
		title: '系统登录',
		logIn: '登录',
		username: '账号',
		password: '密码',
		any: '随便填',
		thirdparty: '第三方登录',
		thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
	},
	documentation: {
		documentation: '文档',
		github: 'Github 地址'
	},
	permission: {
		createRole: '新增角色',
		editPermission: '编辑权限',
		roles: '你的权限',
		switchRoles: '切换权限',
		tips:
			'在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
		delete: '删除',
		confirm: '确定',
		cancel: '取消'
	},
	guide: {
		description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
		button: '打开引导'
	},
	components: {
		documentation: '文档',
		tinymceTips:
			'富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
		stickyTips: '当页面滚动到预设的位置会吸附在顶部',
		backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
		backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
		imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。',
		changeLanguageTips: '切换语言成功'
	},
	table: {
		dynamicTips1: '固定表头, 按照表头顺序排序',
		dynamicTips2: '不固定表头, 按照点击顺序排序',
		dragTips1: '默认顺序',
		dragTips2: '拖拽后顺序',
		title: '标题',
		importance: '重要性',
		type: '类型',
		remark: '点评',
		search: '搜索',
		add: '添加',
		export: '导出',
		reviewer: '审核人',
		id: '序号',
		date: '时间',
		author: '作者',
		readings: '阅读数',
		status: '状态',
		actions: '操作',
		edit: '编辑',
		publish: '发布',
		draft: '草稿',
		delete: '删除',
		cancel: '取 消',
		confirm: '确 定'
	},
	example: {
		warning:
			'创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
	},
	errorLog: {
		tips: '请点击右上角bug小图标',
		description:
			'现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
		documentation: '文档介绍'
	},
	excel: {
		export: '导出',
		selectedExport: '导出已选择项',
		placeholder: '请输入文件名(默认excel-list)'
	},
	zip: {
		export: '导出',
		placeholder: '请输入文件名(默认file)'
	},
	pdf: {
		tips: '这里使用 window.print() 来实现下载pdf的功能'
	},
	theme: {
		change: '换肤',
		documentation: '换肤文档',
		tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
	},
	tagsView: {
		refresh: '刷新',
		close: '关闭',
		closeOthers: '关闭其它',
		closeAll: '关闭所有'
	},
	settings: {
		title: '系统布局配置',
		theme: '主题色',
		showTagsView: '显示 Tags-View',
		showSidebarLogo: '显示侧边栏 Logo',
		fixedHeader: '固定 Header',
		sidebarTextTheme: '侧边栏文字主题色'
	},
	msg: {
		loading: '正在处理数据，请稍候...',
		error: {
			hasDetail: '错误详细信息如下',
			badRequest: '请求异常',
			unauthorized: '登录状态过期，请重新登录',
			forbidden: '未授权，拒绝访问'
		},
		status: {
			supplierConfirm: '供应商确认中',
			returned: '已退货',
			originalMuseumAudit: '原创馆审批',
			buyerConfirm: '买方确认中',
			relaterAudit: '相关审批人审批',
			approved: '已审批',
			confirm: '已确认',
			financeAudit: '财管审核',
			contractAudit: '合同审核',
			taxAudit: '税务审核',
			businessFinancialAudit: '业务线财管审批',
			businessDeptHeadAudit: '业务部门负责人审批',
			coopDeptHeadAudit: '产业生态合作部负责人审批',
			audited: '审批完成',
			cancelled: '已作废',
			vendorConfirm: '等待供应商确认',
			purchaserConfirm: '采购确认',
			leaderAudit2: '直属Leader审批',
			centerChargerAudit: '业务总监审批',
			priceLibrary: '已进价格库',
			vendorAlreadyConfirm: '供应商已确认',
			finished: '已完成',
			businessConfirm: '业务方确认中',
			supplierrefuse: '供应商拒绝',
			simple: '简单',
			complex: '复杂',
			enquirying: '询价中',
			quoted: '已报价',
			opened: '打开报价',
			priceLibrarying: '生成价格库中',
			deptGMAudit: '部门GM审批',
			isuxGMAudit: 'isux-GM审批',
			coopDeptAudit: '产业生态合作部GM审批',
			financialAudit: '财管审批',
			leaderApprovalAudit: '直属Leader审批',
			pendingSummary: '待汇总审批',
			summary: '已汇总待审批',
			rejected: '已驳回',
			canceled: '已取消',
			syncing: '数据同步中',
			agentAudit: '经办人审批',
			centerCharger: '业务总监审批',
			purchaseAudit: '采购审批',

			// -----------决策映射状态-----------
			draft: '草稿',
			processing: '系统处理中',
			pendingConfirm: '待供应商确认接单',
			relateApprovalAudit: '相关审批人审批',
			leaderAudit: 'Leader审批',
			agentLeaderAudit: '经办人Leader审批',
			deptTaxAudit: '部门税务审批',
			deptFinanceAudit: '部门财管审批',
			GMAudit: '业务GM审批',
			GMAuditIEG: '经办人GM审批',
			financeDCAudit: '财务DC审批',
			EVPAudit: 'EVP审批',
			CXOAudit: 'CXO审批',
			CFOAudit: 'CFO审批',
			CEOAudit: 'CEO审批',
			CenterChargerAudit: '经办人总监审批',
			chairmanAudit: '总裁审批',
			effective: '已生效',
			terminated: '已终止',
			stopped: '已终止',
			deleted: '已删除',
			partialAcceptance: '部分验收',
			pendingAcceptance: '待验收',
			partAcceptance: '部分验收',
			inAcceptance: '验收中',
			acceptance: '已验收',
			invalid: '已作废',
			toAddedApprovalMail: '待补充审批邮件',
			cancel: '主动作废',
			reject: '已驳回',
			unconfirmed: '待确认',
			Apply: '提交申请',
			// -----------结算付款状态-----------
			init: '待付款',
			processVal: '处理中',
			success: '处理成功',
			fail: '付款失败',
			supplier_refuse: '已拒绝',
			supplierHasConfirmed: '供应商已确认接单',

			closeAcceptance: '已关闭验收',
			relaterApproval: '相关人审批',
			approvalCompleted: '审批完成',
			closed: '已关闭'
		}
	}
};
export default {
	decision,
	material,
	requirement,
	purchaseorder,
	system,
	settlement,
	evaluationApplication,
	evaluationResults,
	evaluationMetrics,
	// merchant
	// personalWorkstation,
	merchantManagement,
	qualificationManagement,
	systemManagement,
	certificateManagement,
	authorizationLetterManagement,
	changeManagement,
	configManagement,
	portal,

	// inquiry,
	msg: {
		loading: 'Data is processing, please wait a moment...',
		error: {
			hasDetail: '错误详细信息如下',
			badRequest: '请求异常',
			unauthorized: '登录状态过期，请重新登录',
			forbidden: '未授权，拒绝访问'
		}
	},
	common,
	...commonLang
};
